import React from 'react'
import styled from '@emotion/styled'
import Banner2 from 'style/icons/pie.png'
import { Button } from 'antd'
import { colors } from 'style/theme'
import { hasPermission } from 'utils/hasPermission'
import { MANAGE_SCAN_PERMISSION } from 'utils/constants'
import { useUser } from 'context/user-context'

const StyledNoScans = styled.div({
  textAlign: 'center'
})
const NoScansTitle = styled.h1({
  marginTop: 15,
  fontWeight: 400
})

const NoScansSubtitle = styled.h2({
  color: colors.brandGray,
  margin: '15px 0',
  fontWeight: 400,
  fontSize: 16
})
const NoScanSettings = ({ navigate }) => {
  const user = useUser()
  let allowCreate = hasPermission(user.permissions, MANAGE_SCAN_PERMISSION)
  return (
    <StyledNoScans>
      <img src={Banner2} width={400} alt="banner" />
      <NoScansTitle>YOU HAVE NO SCANS YET</NoScansTitle>
      {allowCreate && (
        <>
          <NoScansSubtitle>LETS CREATE ONE</NoScansSubtitle>
          <Button id="firstScanSettings" type="primary" size="large" onClick={() => navigate('new-simple-scan')}>
            CREATE SCAN SETTINGS
          </Button>
        </>
      )}
    </StyledNoScans>
  )
}

export default NoScanSettings
